import tw from 'twin.macro'
import React, { useContext } from 'react'
import { TableSearch } from 'src/components/shared/table/TableSearch'
import { SubcontractorRequestsTableContext } from '../SubcontractorRequestsTable.context'
import { SubcontractorRequestsMCSelect } from './SubcontractorRequestsMCSelect'
import { SubcontractorRequestsBatchActionButton } from './SubcontractorRequestsBatchActionButton'
import { GridColumnsSelect } from 'src/components/shared/grid/grid-columns-select/GridColumnsSelect'

export const SubcontractorRequestsHeader = () => {
  const {
    setSearchQuery,
    searchQuery,
    columnsConfig,
    columnVisibilityModel,
    pinnedColumns,
    lockedColumns,
    onToggleColumnVisibility,
    onColumnVisibilityModelChange,
    onPinColumn,
    onUnpinColumn,
  } = useContext(SubcontractorRequestsTableContext)

  return (
    <div
      css={tw`flex flex-row items-center justify-between px-4 py-3 bg-white border-0 border-b border-t border-solid border-[#EDEDED]`}
    >
      <div css={tw`flex flex-row items-center gap-2`}>
        {columnsConfig.length > 0 && (
          <GridColumnsSelect
            columnsConfig={columnsConfig}
            columnVisibilityModel={columnVisibilityModel}
            pinnedColumns={pinnedColumns}
            lockedColumns={lockedColumns}
            onToggleColumnVisibility={onToggleColumnVisibility}
            onColumnVisibilityModelChange={onColumnVisibilityModelChange}
            onPinColumn={onPinColumn}
            onUnpinColumn={onUnpinColumn}
          />
        )}
        <TableSearch
          searchQuery={searchQuery}
          onChangeSearchQuery={setSearchQuery}
          className="w-[284px]"
          inputDataTestId="requests-main-search-input"
          clearButtonDataTestId="requests-main-search-clear-btn"
        />
        <SubcontractorRequestsMCSelect />
      </div>
      <SubcontractorRequestsBatchActionButton />
    </div>
  )
}
